import { alertAnatomy } from "@chakra-ui/anatomy";
import {
  createMultiStyleConfigHelpers,
  StyleFunctionProps,
  SystemStyleObject,
} from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(alertAnatomy.keys);

type StatusStyleConfig = {
  color: string;
  bg: string;
  darkColor: string;
  darkBg: string;
};

type StatusStyles = {
  [key: string]: StatusStyleConfig;
};

const statusStyles: StatusStyles = {
  error: {
    color: "red.500",
    bg: "red.100",
    darkColor: "white",
    darkBg: "red.900",
  },
  success: {
    color: "green.600",
    bg: "green.100",
    darkColor: "white",
    darkBg: "green.900",
  },
  warning: {
    color: "yellow.700",
    bg: "yellow.200",
    darkColor: "white",
    darkBg: "yellow.900",
  },
  info: {
    color: "blue.600",
    bg: "blue.100",
    darkColor: "white",
    darkBg: "blue.900",
  },
};

const baseStyle = definePartsStyle(
  (props: StyleFunctionProps): Record<string, SystemStyleObject> => {
    const { status } = props;
    const statusStyle =
      statusStyles[status as keyof StatusStyles] || statusStyles.info;

    return {
      title: {
        fontFamily: "header",
        color: statusStyle.color,
        _dark: {
          color: statusStyle.darkColor,
        },
      },
      description: {
        color: statusStyle.color,
        fontSize: "bodySmall",
        _dark: {
          color: statusStyle.darkColor,
        },
      },
      container: {
        bg: statusStyle.bg,
        _dark: {
          bg: statusStyle.darkBg,
        },
      },
      icon: {
        color: statusStyle.color,
      },
    };
  }
);

const alertTheme = defineMultiStyleConfig({ baseStyle });

export default alertTheme;
